var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIc16SocialTiktok = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  fillRule: "evenodd",
  d: "M10.49 2c.198 1.703 1.148 2.718 2.8 2.826v1.915c-.957.094-1.796-.22-2.771-.81v3.582c0 4.551-4.961 5.973-6.956 2.711-1.282-2.098-.497-5.781 3.615-5.93v2.02a5.95 5.95 0 0 0-.954.235c-.915.31-1.433.889-1.29 1.911.278 1.959 3.87 2.538 3.572-1.289V2.004h1.984V2Z",
  clipRule: "evenodd"
})));
export default SvgIc16SocialTiktok;